import type { LocationQueryValue } from 'vue-router'
import { ApiServiceBase } from './ApiServiceBase'

type Query = {
  filter?: string | LocationQueryValue[]
  perPage?: number | LocationQueryValue[]
  page?: number
}

export default class extends ApiServiceBase {
  async index(campaignId: number, query: Query) {
    return useAsyncData('campaign-approaches-index', () => this.call(`/spa/campaigns/${campaignId}/approaches`, {
      query: {
        ...query,
        onlyEnabled: true,
      },
    }))
  }

  async store(campaignId: number, approachId: number): Promise<any> {
    return await this.call(`/spa/campaigns/${campaignId}/approaches/${approachId}`, {
      method: 'post',
    })
  }

  async update(campaignId: number, approachId: number, data: any): Promise<any> {
    return await this.call(`/spa/campaigns/${campaignId}/approaches/${approachId}`, {
      method: 'put',
      body: data,
    })
  }

  async delete(campaignId: number, approachId: number): Promise<any> {
    return await this.call(`/spa/campaigns/${campaignId}/approaches/${approachId}`, {
      method: 'delete',
    })
  }

  async generateCouponCode(campaignId: number, approachId: number, data: any): Promise<any> {
    return await this.call(`/spa/campaigns/${campaignId}/approaches/${approachId}/coupon`, {
      method: 'post',
      body: data,
    })
  }
}
